var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-select',{staticClass:"appup-dropdown",attrs:{"id":_vm.id,"options":_vm.dropdownItems,"state":_vm.state},on:{"change":_vm.onSelect},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/inputs/dropdown/dropdown.vue